import { render, staticRenderFns } from "./ReportMealsTabReservedMeals.vue?vue&type=template&id=1cddd157"
import script from "./ReportMealsTabReservedMeals.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabReservedMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports